import { BlogPostSlice } from '@adapters/prismic/types/blogPost';
import { ContentPageSlice } from '@adapters/prismic/types/contentPage';

import MarkdownCopy from '../Slices/MarkdownCopy';
import ImageWithCaption from '../Slices/ImageWithCaption';
import ImageWithBlock from '../Slices/ImageWithBlock';
import Actions from '../Slices/Actions';
import MediaEmbed from '../Slices/MediaEmbed';
import IFrameEmbed from '../Slices/IFrameEmbed';
import InlineAlert from '../Slices/InlineAlert';
import FormEmbed from '../Slices/FormEmbed';
import DropDown from '../Slices/DropDown';

const createValidHtmlId = (value?: string | null): string | undefined => {
  if (!value) return undefined;
  const id = value.replace(/[^\w\-]/g, '_');
  return id.charAt(0).match(/[a-zA-Z_]/) && !id.startsWith('_')
    ? id
    : `id_${id}`;
};

const SliceHandler = ({
  slice,
  pageType,
}: {
  slice: BlogPostSlice | ContentPageSlice;
  pageType: 'blog' | 'content';
}) => {
  const htmlId = createValidHtmlId(slice.primary?.id);
  switch (slice?.slice_type) {
    case 'markdowncopy':
      return slice.primary?.copy?.length > 0 ? (
        <div id={htmlId}>
          {slice.primary?.copy?.map(({ text }: { text: string }) => (
            <MarkdownCopy key={text.substring(0, 50)} text={text} />
          ))}
        </div>
      ) : null;
    case 'image':
      return (
        <ImageWithCaption
          id={htmlId}
          image={slice.primary.image}
          caption={slice.primary?.copy?.[0]?.text ?? null}
          link={slice.primary.link}
          fullWidthImage={pageType === 'blog'}
        />
      );
    case 'vertimage':
      return (
        <ImageWithBlock
          id={htmlId}
          image={slice.primary.vert_image}
          copy={slice.primary.vert_copy}
          link={slice.primary.vert_link}
        />
      );
    case 'action':
      return <Actions id={htmlId} items={slice.items} />;
    case 'mediaembed':
      return <MediaEmbed id={htmlId} embed={slice.primary.embed} />;
    case 'iframeembed':
      return (
        <IFrameEmbed
          url={slice.primary.iframe_url}
          title={slice.primary.iframe_title}
          width={slice.primary.iframe_width}
          height={slice.primary.iframe_height}
        />
      );
    case 'inlinealert':
      return (
        <InlineAlert
          text={slice.primary.text[0].text}
          messageType={slice?.primary?.alerttype}
        />
      );
    case 'formembed':
      return <FormEmbed html={slice.primary.embedcode} />;
    case 'dropdown':
      return (
        <DropDown
          title={slice.primary.title1[0].text}
          copy={slice.primary?.copy?.[0].text ?? ''}
          isOpen={slice.primary.isopen}
        />
      );
    default:
      return null;
  }
};

export default SliceHandler;
